module.exports = __webpack_public_path__ + "img/normal_multiplier_7.a0f300a0.png";